import { createContext, useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import LayoutMain from 'components/layouts/LayoutMain';
import LoadingComponent from 'components/LoadingComponent';
import { useChat } from 'hooks/useChat';
import Menu from 'pages/Chat/_components/Menu';
import ScreenChat from 'pages/Chat/_components/ScreenChat';
import { resetChat } from 'store/actions/chat';
import { calculatorHeightContain } from 'utils/helper';

export const ChatContext = createContext(null);

const Chats = () => {
  const dispatch = useDispatch();
  const chatContextValue = useChat();

  const { currentConversation, loadingScreenChat } = useSelector((state) => state.chat);

  const [heightChat, setHeightChat] = useState(0);
  const [message, setMessage] = useState({});

  useEffect(() => {
    const height = calculatorHeightContain([{ id: 'layout-chat' }], [{ id: 'main' }]);
    setHeightChat(height);
  }, []);

  useEffect(() => {
    return () => {
      dispatch(resetChat());
    };
  }, []);

  return (
    <ChatContext.Provider value={{ ...chatContextValue, message, setMessage }}>
      <LayoutMain id="layout-chat" className={'!max-w-full !bg-transparent !py-2 flex flex-col h-full'}>
        <div className="flex items-start gap-8 h-full">
          <div className="w-[510px] bg-white flex-shrink-0" style={{ height: heightChat }}>
            <Menu />
          </div>
          <div className="w-full bg-white" style={{ height: heightChat }}>
            {currentConversation && currentConversation !== -1 ? (
              loadingScreenChat ? (
                <LoadingComponent />
              ) : (
                <ScreenChat />
              )
            ) : (
              <div className="flex items-center justify-center h-full"></div>
            )}
          </div>
        </div>
      </LayoutMain>
    </ChatContext.Provider>
  );
};

export default Chats;
